import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BaseComponent } from '../../../common/base.component';
import { FilterTitleComponent } from '../../../common/filter-title/filter-title.component';
import { Filter, WeaponFilter } from '../../../models/filter-models';
import { FilterService } from '../../../services/filter.service';
import { WeaponFilterComponent } from './weapon-filter/weapon-filter.component';
import { ActiveSpecialRules } from '../../../services/filter-generator.service';
import { confirmRemove } from '../../../common/confirm-remove';
import { DynamicContentComponent } from '../../../common/dynamic-content/dynamic-content.component';

@Component({
  selector: 'app-my-weapons-list',
  imports: [FormsModule, FilterTitleComponent, WeaponFilterComponent, DynamicContentComponent],
  templateUrl: './my-weapons-list.html',
  styleUrl: './my-weapons-list.scss'
})
export class MyWeaponsListComponent extends BaseComponent {
  @Input({ required: true }) filter!: Filter;
  @Input({ required: true }) activeSpecialRules!: ActiveSpecialRules;

  constructor(private filterService: FilterService) {
    super();
  }

  removeWeaponType(index: number) {
    if (!confirmRemove('Are you sure you want to remove this Weapon Type?')) return;
    this.filter.weaponFilters.splice(index, 1);
    this.updateFilter();
  }

  addWeaponType = () => { this.filter.weaponFilters.push(new WeaponFilter()); this.updateFilter(); }

  updateFilter() {
    this.filterService.updateFilter();
  }
}
